module.exports = new __parcel__URL__("thewickbar.8e7aed45.png").toString();